import VerifySlider from './src/main'

VerifySlider.install = function (Vue) {
  Vue.component(VerifySlider.name, VerifySlider)
}

export default VerifySlider
